/**
 * Finds the nicest number approximately equal to val.
 * Nice is defined as 1, 2, 3, 5, or 10 times 10^n.
 * This matches the algorithm ECharts uses for finding tick intervals,
 * so we use it to find min/max values that line up nicely with the ticks.
 *
 * @param val - Must be a positive number. Returns 0 for non-positive inputs
 * since Math.log10 is undefined for val <= 0.
 */
export function niceNum(val: number): number {
  if (val <= 0) {
    return 0;
  }

  const exponent = Math.floor(Math.log10(val));
  const exp10 = Math.pow(10, exponent);

  const fraction = val / exp10;
  let niceFraction = 1;

  if (fraction < 1.5) {
    niceFraction = 1;
  } else if (fraction < 2.5) {
    niceFraction = 2;
  } else if (fraction < 4) {
    niceFraction = 3;
  } else if (fraction < 7) {
    niceFraction = 5;
  } else {
    niceFraction = 10;
  }

  niceFraction = niceFraction * exp10;

  return exponent >= -20 ? +niceFraction.toFixed(exponent < 0 ? -exponent : 0) : niceFraction;
}
